import styles from '@ui/components/Voting/components/ProgressBar/ProgressBar.module.scss';
import Content from '@ui/components/Content/Content';
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const ProgressBar = ({ answer, duration = 20, selected, value }) => {
  const [count, setCount] = useState(0);
  const backgroundImage = `linear-gradient(to right, #EEEFF1 ${count}%, white ${count}% 100%)`;

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (count < value) {
        setCount(prev => prev + 1);
      }
    }, duration);

    return () => clearTimeout(timeout);
  }, [count]);

  return (
    <div
      className={classNames(styles.container, {
        [styles.selected]: selected,
      })}
      key={answer}
      style={{ backgroundImage }}
    >
      <Content as="dt" noSpacing size="lg">
        {answer}
      </Content>
      <Content as="dd" noSpacing size="lg">
        {count}%
      </Content>
    </div>
  );
};

ProgressBar.propTypes = {
  answer: PropTypes.string.isRequired,
  duration: PropTypes.number,
  selected: PropTypes.bool.isRequired,
  value: PropTypes.number.isRequired,
};

export default ProgressBar;
